import _slicedToArray from "/home/strapiadmin/gatsby/www.theamx.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useReducer, useEffect, useCallback } from 'react';

function reducer(state, action) {
  switch (action.type) {
    case "set":
      return state = action.payload;

    default:
      return state;
  }
}
/**
 * useSessionstorage
 * Tracks a value within sessionStorage and updates it
 * @param key Key of the value to be stored
 * @param defaultValue Default value of the stored item
 */


function useSessionstorage(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useReducer = useReducer(reducer, getValueFromSessionStorage()),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      value = _useReducer2[0],
      dispatch = _useReducer2[1];

  function init() {
    var initialValue = getValueFromSessionStorage();

    if (initialValue === null || initialValue === "null") {
      set(defaultValue);
    }
  }

  function getValueFromSessionStorage() {
    if (typeof sessionStorage === "undefined") {
      return null;
    }

    var storedValue = sessionStorage.getItem(key) || "null";

    try {
      return JSON.parse(storedValue);
    } catch (err) {
      console.error(err);
    }

    return storedValue;
  }

  function saveValueToSessionStorage(key, value) {
    if (typeof sessionStorage === "undefined") {
      return null;
    }

    return sessionStorage.setItem(key, JSON.stringify(value));
  }

  function setValue(value) {
    dispatch({
      type: "set",
      payload: value
    });
  }

  function set(newValue) {
    saveValueToSessionStorage(key, newValue);
    setValue(newValue);
  }

  function remove() {
    if (typeof sessionStorage === "undefined") {
      return null;
    }

    sessionStorage.removeItem(key);
    setValue(null);
  }

  useEffect(function () {
    init();
  }, []);
  var listen = useCallback(function (e) {
    if (e.storageArea === sessionStorage && e.key === key) {
      set(e.newValue);
    }
  }, []);
  useEffect(function () {
    window.addEventListener("storage", listen);
    return function () {
      window.removeEventListener("storage", listen);
    };
  }, []);
  var handler;
  handler = [value, set, remove];
  handler.value = value;
  handler.set = set;
  handler.remove = remove;
  return handler;
}

export default useSessionstorage;